import Storage from './modules/Storage.js';

var storage = new Storage('local');
storage.remove('dashboard');
storage.remove('minor-modal-viewed');

const loginForm = document.querySelector('#login-form')
loginForm.addEventListener('submit', function () {
    window.localStorage.setItem('notice-modal', JSON.stringify({ 'show': true }))
})

function resetCaptcha() {
    if (typeof grecaptcha != 'undefined') {
        return grecaptcha.reset();
    }
}

resetCaptcha();
